export default (theme) => ({
    paper: {
        width: 600
    },
    textField: {
        width: '100%'
    }
});